var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChefHat = function SvgChefHat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 77 77"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: "m19.708 54.434 37.885-.028m-19.2-44.8c6.138 0 11.264 4.32 12.512 10.083a12.8 12.8 0 0 1 16.04 13.996 12.8 12.8 0 0 1-9.352 10.717v22.804h-38.4V44.402a12.803 12.803 0 0 1 6.695-24.713A12.8 12.8 0 0 1 38.393 9.605"
  })));
};
export default SvgChefHat;